<template>
  <div class="web">
    <!-- 协议弹窗 (移动到顶层以避免容器样式干扰) -->
    <a-modal :visible="submitShow" title="场地使用协议" width="800px" @ok="submit" @cancel="submitShow = false" :ok-button-props="{ props: { disabled: !submitChecked } }" ok-text="确认预约" cancel-text="返回修改" :z-index="10000" :centered="true">
      <div class="agreement-container-pc">
        <div v-if="agreement" class="agreement-content-scroll">
          <h2 class="agreement-h2">{{ agreement.split('\n')[0] }}</h2>
          <div class="agreement-body">
            <p v-for="(item, index) in agreement.split('\n')" :key="index" v-if="index !== 0" v-html="item"></p>
          </div>
        </div>
        <div v-else class="agreement-content-scroll">
          <h2 class="agreement-h2">场地管理规定</h2>
          <div class="agreement-body">
            <p>1. 预约后如须变动，须提前2小时（不含）取消，未按时取消的，费用不退。</p>
            <p>2. 运动参与者如患有不适合体育运动的疾病的（如心脏病、高血压、哮喘等），应根据自身体情况开展运动。因运动参与者自身原因在运动过程中突发疾病引起的一切后果由其自负。</p>
            <p>3. 运动参与者对运动过程中可能遭受的人身伤害风险有充分的预知并愿意承担此种风险。如发生伤害按照法律规定自行承担或者由相关责任人承担责任。体育场地提供者对运动过程中遭受的非运动设施造成的人身伤害无过错且不承担任何赔偿责任。</p>
            <p>4. 运动参与者在运动过程中相互之间发生纠纷，双方需保持理性与克制，如产生暴力冲突及因此产生人身财产损失，由双方按照相应法律规定自行承担相应责任，与场地提供者无关。</p>
            <p>5. 运动参与者应自行保管好随身携带的物品，场地提供者不负保管责任。</p>
            <p>6. 运动参与者若使用场地内更衣室（含淋浴），请小心地滑。在使用过程中发生的任何意外事故，场地提供者不承担赔偿责任。</p>
          </div>
        </div>
        <div class="agreement-footer-pc">
          <a-checkbox v-model="submitChecked">本人已认真阅读、充分了解并自愿接受上述规定。</a-checkbox>
        </div>
      </div>
    </a-modal>

    <div class="pc-box">
      <!-- 头部 -->
      <div class="pc-header">
        <div class="pc-header-auto">
          <span>
            <img src="@/assets/logo.png" @click="$router.push('/')">
            <em>场馆预约</em>
          </span>
        </div>
      </div>

      <!-- 内容区 -->
      <div class="pc-content">
        <!-- 页面标题与面包屑 -->
        <div class="page-nav">
          <a-breadcrumb>
            <a-breadcrumb-item><a @click="$router.push('/venueDetail-pc')">首页</a></a-breadcrumb-item>
            <a-breadcrumb-item>场馆预约</a-breadcrumb-item>
          </a-breadcrumb>
          <a-button type="primary" @click="$router.push('/orderIndex-pc')" class="booking-btn">
            预约记录
          </a-button>
        </div>

        <div class="reserve-main-layout">
          <!-- 左侧：预约主体 -->
          <div class="reserve-content-area">
            <div class="selection-panel">
              <div class="panel-section" v-if="hasEnclosure === '1'">
<!--                <div class="section-title-small">选择模式</div>-->
<!--                <a-radio-group v-model="chargeTypeCurrent" @change="chargeTypeChange" button-style="solid">-->
<!--                  <a-radio-button :value="0">{{ getDictName(chargeTypeOptions, chargeType) }}</a-radio-button>-->
<!--                  <a-radio-button :value="1">{{ getDictName(chargeTypeOptions, chargeType) === '半天' ? '全天' : '包场' }}</a-radio-button>-->
<!--                </a-radio-group>-->
              </div>

              <div class="panel-section">
                <div class="section-title-small">选择日期</div>
                <div class="week-selector-pc">
                  <div v-for="(item, index) in weekList" :key="index"
                       class="week-card-pc" :class="{'active': item.split(',')[0] === weekCurrent}"
                       @click="weekChange(item.split(',')[0])">
                    <div class="week-day">{{ item.split(',')[1] }}</div>
                    <div class="week-date">{{ item.split(',')[0].substring(5) }}</div>
                  </div>
                </div>
              </div>

              <div class="legend-panel">
                <div class="legend-item"><span class="box not-optional"></span>不可选</div>
                <div class="legend-item"><span class="box optional"></span>可选</div>
                <div class="legend-item"><span class="box selected"></span>已选</div>
<!--                <div class="bc-notice" v-if="chargeTypeCurrent === 1">-->
<!--                  <a-icon type="info-circle" />-->
<!--                  当前为{{ getDictName(chargeTypeOptions, chargeType) === '半天' ? '全天' : '包场' }}模式：-->
<!--                  <span class="highlight">{{ bcDuration }}小时 / {{ bcPrice }}元</span>-->
<!--                </div>-->
              </div>
            </div>

            <!-- 预约表格 -->
            <div class="reserve-grid-container">
              <div class="table-wrapper">
                <table class="venue-reserve-table-pc">
                  <thead>
                    <tr>
                      <th class="sticky-col first-col">时间段</th>
                      <th v-for="(item, index) in groundList" :key="index">{{ item.groundName }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, key, index) in reserveInfo" :key="index">
                      <td class="sticky-col time-label">
                        {{ sportType === '20' ? (index === 0 ? '午餐' : index === 1 ? '晚餐' : key) : key }}
                      </td>
                      <td v-for="(item2, index2) in groundList" :key="index2">
                        <div v-if="item[item2.id]" class="cell-content">
                          <!-- 单次 -->
                          <template v-if="chargeTypeCurrent === 0">
                            <div v-if="item[item2.id].isEnclosure === '1'
                                      || item[item2.id].reserveNum >= item[item2.id].availableNum
                                      || item[item2.id].status !== '1'
                                      || item[item2.id].specifyUser !== '1'
                                      || getSelfReserveTimeNum(item) > 0
                                      || isOverdueSession(item[item2.id])
                                      || checkBrokeRecoveryDate()
                                      || checkAdvanceBookingDate()"
                                 class="reserve-slot disabled">
                              <span class="slot-price">预约</span>
                            </div>
                            <div v-else class="reserve-slot available"
                                 :class="{'selected': selectIds.includes(item[item2.id].groundSessionId)}"
                                 @click="selectGround(item[item2.id])">
                              <span class="slot-price">预约</span>
                              <span class="slot-check" v-if="selectIds.includes(item[item2.id].groundSessionId)">
                                <a-icon type="check-circle" theme="filled" />
                              </span>
                            </div>
                          </template>
                          <!-- 包场 -->
                          <template v-else>
                            <div v-if="item[item2.id].isEnclosure === '1'
                                      || item[item2.id].reserveNum > 0
                                      || item[item2.id].enclosureStatus !== '1'
                                      || item[item2.id].specifyUser !== '1'
                                      || moment().format('YYYY-MM-DD') === item[item2.id].sessionDate
                                      || isOverdueSession(item[item2.id])"
                                 class="reserve-slot disabled">
                              -
                            </div>
                            <div v-else class="reserve-slot available"
                                 :class="{'selected': selectIds.includes(item[item2.id].groundSessionId)}"
                                 @click="selectGround(item[item2.id])">
                              预约
                              <span class="slot-check" v-if="selectIds.includes(item[item2.id].groundSessionId)">
                                <a-icon type="check-circle" theme="filled" />
                              </span>
                            </div>
                          </template>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- 右侧：结算面板 -->
          <div class="reserve-sidebar">
            <div class="sidebar-card">
              <h3 class="sidebar-title">预约确认</h3>

              <div class="sidebar-section">
                <div class="section-label">订单备注</div>
                <a-textarea v-model="orderRemark" placeholder="请输入您的特殊需求..." :rows="3" :maxLength="100" />
              </div>

              <div class="sidebar-section" v-if="serviceSports.includes(this.sportType)">
                <div class="section-label">附加服务</div>
                <a-button block icon="plus" @click="openService">添加服务</a-button>
                <div class="service-summary" v-if="selectServiceNum > 0">
                  已选择 <span class="count">{{ selectServiceNum }}</span> 项服务
                </div>
              </div>

              <a-divider />

<!--              <div class="price-details-pc">-->
<!--                <div class="price-item">-->
<!--                  <span>场租费用</span>-->
<!--                  <span>￥0.00</span>-->
<!--                </div>-->
<!--                <div class="price-item" v-if="selectServiceAmount > 0">-->
<!--                  <span>服务费用</span>-->
<!--                  <span>￥0.00</span>-->
<!--                </div>-->
<!--                <div class="price-item discount">-->
<!--                  <span>会员优惠</span>-->
<!--                  <span>-￥0.00</span>-->
<!--                </div>-->
<!--                <div class="price-total">-->
<!--                  <span>合计应付</span>-->
<!--                  <span class="total-val">￥0.00</span>-->
<!--                </div>-->
<!--              </div>-->

              <a-button type="danger" size="large" block class="submit-booking-btn" @click="openDialog">
                提交预约
              </a-button>

              <div class="notice-info">
                <h4 class="notice-title">预约须知</h4>
                <div class="notice-content-pc" v-html="remark"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="foot">Copyright © www.senergy.sjtu.edu.cn. All Rights Reserved</div>
    </div>

    <service-cart-pc ref="serviceCart" @handleOk="serviceOk"/>
  </div>
</template>

<script>
import moment from "moment"
import { FILE_DISPLAY_PREFIX } from '@/api/upload'
import { getDictByType } from '@/api/common'
import { getDictName } from '@/utils/common'
import { reserveInfo } from '@/api/venue/venue'
import ServiceCartPc from '@/views/components/ServiceCartPc'
import {
  Card, Radio, Button, Row, Col, Input, Divider, Modal, Checkbox,
  Icon, message, Breadcrumb
} from 'ant-design-vue'
import {submitPc} from "../../api/venue/venue";
import {pay} from "@/api/order/order";

export default {
  name: 'VenueReservePc',
  components: {
    ServiceCartPc,
    'a-card': Card,
    'a-radio-group': Radio.Group,
    'a-radio-button': Radio.Button,
    'a-button': Button,
    'a-row': Row,
    'a-col': Col,
    'a-textarea': Input.TextArea,
    'a-divider': Divider,
    'a-modal': Modal,
    'a-checkbox': Checkbox,
    'a-icon': Icon,
    'a-breadcrumb': Breadcrumb,
    'a-breadcrumb-item': Breadcrumb.Item
  },
  data() {
    return {
      venueId: '',
      sportType: '',
      loading: false,
      submitChecked: false,
      submitShow: false,
      chargeTypeCurrent: 0,
      weekCurrent: moment().format('YYYY.MM.DD'),
      weekList: [],
      reserveInfo: {},
      groundList: [],
      chargeTypeOptions: [],
      chargeType: '',
      hasEnclosure: '',
      bcPrice: '',
      bcDuration: '',
      remark: '',
      agreement: '',
      orderRemark: '',
      brokeRecoveryDate: undefined,
      advanceBookingDate: undefined,
      venueConfig: {},
      discount: 0,
      discountType: 0,
      serviceDiscount: 0,
      selectList: [],
      selectService: [],
      amount: 0,
      selectServiceAmount: 0,
      selectServiceNum: 0,
      serviceSports: [],
      fileDisplayPrefix: FILE_DISPLAY_PREFIX,
      moment,
      getDictName
    }
  },
  computed: {
    selectIds() {
      return this.selectList.map(i => i.groundSessionId)
    },
    // 优惠价格
    // eslint-disable-next-line vue/no-dupe-keys
    discountPrice() {
      // 计算商品折扣
      const goodsDiscountPrice = (this.amount * this.discount / 100).toFixed(2)

      // 计算服务折扣
      let serviceDiscountPrice = 0
      if (this.discountType === '0') {
        serviceDiscountPrice = (this.selectServiceAmount * this.discount / 100).toFixed(2)
      } else {
        serviceDiscountPrice = (this.selectServiceAmount * this.serviceDiscount / 100).toFixed(2)
      }

      // 折扣合计
      return parseInt(goodsDiscountPrice) + parseInt(serviceDiscountPrice)
    }
  },
  created() {
    this.venueId = this.$route.query.venueId
    this.sportType = this.$route.query.sportType
    this.initWeek()
    this.refresh()
  },
  methods: {
    initWeek() {
      const weeks = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
      for (let i = 0; i < 7; i++) {
        const date = moment().add(i, 'days')
        this.weekList.push(date.format('YYYY.MM.DD') + ',' + weeks[date.day()])
      }
    },
    refresh() {
      this.getDict()
      this.getData()
    },
    getDict() {
      getDictByType('charge_type').then(res => {
        if (res.code === 10000) {
          this.chargeTypeOptions = res.result.map(item => ({
            label: item.dictKey,
            value: item.dictValue
          }))
        }
      })
    },
    getData() {
      const params = {
        venueId: this.venueId,
        sportType: this.sportType,
        sessionDate: this.weekCurrent.replace(/\./g, '-'),
        chargeType: this.chargeTypeCurrent
      }
      reserveInfo(params).then(res => {
        if (res.code === 10000) {
          this.reserveInfo = res.result.reserveInfo
          this.groundList = res.result.groundList
          this.chargeType = res.result.chargeType
          this.hasEnclosure = res.result.hasEnclosure
          this.bcPrice = res.result.bcPrice
          this.bcDuration = res.result.bcDuration
          this.remark = res.result.remark
          this.agreement = res.result.agreement
          this.serviceDiscount = res.result.serviceDiscount || 0
          this.discount = res.result.discount || 0
          this.discountType = res.result.discountType
          this.serviceSports = res.result.serviceSports || []
          this.brokeRecoveryDate = res.result.brokeRecoveryDate
          this.advanceBookingDate = res.result.advanceBookingDate
          this.venueConfig = res.result.venueConfig || {}
          this.calculateAmount()
        }
      })
    },
    weekChange(date) {
      this.weekCurrent = date
      this.selectList = []
      this.getData()
    },
    chargeTypeChange() {
      this.selectList = []
      this.getData()
    },
    selectGround(item) {
      const index = this.selectList.findIndex(i => i.groundSessionId === item.groundSessionId)
      if (index > -1) {
        this.selectList.splice(index, 1)
      } else {
        if (this.chargeTypeCurrent === 0) {
          // 单次模式：通常只允许选一个，或者按照业务逻辑覆盖
          this.selectList = [item]
        } else {
          // 多次/包场模式：允许累加
          this.selectList.push(item)
        }
      }
      this.calculateAmount()
    },
    calculateAmount() {
      if (this.selectList.length === 0) {
        this.amount = 0
        return
      }
      // 单次
      if (this.chargeTypeCurrent === 0) {
        this.amount = this.selectList.reduce((sum, item) => sum + (Number(item.price) || 0), 0)
      } else {
        // 包场模式金额计算逻辑，与 H5 版保持一致
        const hours = this.selectList.reduce((sum, i) => sum + (i.hours || 0), 0)
        this.amount = Math.ceil(hours / this.bcDuration) * this.bcPrice || 0
      }
    },
    // 存在至少提前预约日期
    checkAdvanceBookingDate() {
      if (!this.advanceBookingDate) {
        return false
      }
      return moment().isAfter(moment(this.advanceBookingDate, 'YYYY-MM-DD HH:mm:ss'))
    },
    // 存在爽约条件
    checkBrokeRecoveryDate() {
      if (!this.brokeRecoveryDate) {
        return false
      }
      return moment().isBefore(moment(this.brokeRecoveryDate, 'YYYY-MM-DD'))
    },
    // 获取是否过期
    isOverdueSession(item) {
      if (!item.sessionDate || !item.timeSlot) {
        return false
      }
      const sessionDate = item.sessionDate + ' ' + item.timeSlot.split('-')[0]
      return moment(sessionDate, 'YYYY-MM-DD HH:mm').isBefore(moment())
    },
    // 获取相同时间段当前用户预约数
    getSelfReserveTimeNum(item) {
      let num = 0
      Object.keys(item).forEach(i => {
        num += item[i].selfReserveNum || 0
      })
      return num
    },
    openService() {
      this.$refs.serviceCart.show(this.sportType)
    },
    serviceOk(services) {
      this.selectService = services
      this.selectServiceNum = services.reduce((sum, i) => sum + i.num, 0)
      this.selectServiceAmount = services.reduce((sum, i) => sum + (i.num * i.price), 0)
    },
    openDialog() {
      if (this.selectList.length === 0) {
        message.warning('请选择场次')
        return
      }
      this.submitChecked = false
      this.submitShow = true
    },
    submit() {
      if (!this.submitChecked) {
        message.warning('请先同意协议')
        return
      }
      const params = {
        venueId: this.venueId,
        sportType: this.sportType,
        sessionDate: this.weekCurrent.replace(/\./g, '-'),
        type: this.chargeTypeCurrent,
        groundSessionIds: this.selectIds,
        remark: this.orderRemark,
        serviceList: this.selectService,


      }
      submitPc(params).then(res => {
        if (res.code === 10000) {
          this.submitShow = false
          // 预约成功后直接调用支付
          const orderId = res.result
          const payParams = {
            id: orderId,
            payType: '1'  // 在线支付
          }
          pay(payParams).then(payRes => {
            if (payRes.code === 10000) {
              message.success('预约成功')
              this.$router.push({path: `/orderDetail-pc?id=${orderId}`})
            } else {
              message.error(payRes.message || '支付失败')
            }
          }).catch(() => {
            message.error('支付失败')
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.web {
  background: #f0f2f5;
  min-height: 100vh;
}
.pc-header {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ffffff;
  width: 100%;
  height: 80px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  position: sticky;
  top: 0;
  z-index: 1000;
}
.pc-header-auto {
  width: 1200px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.pc-header-auto span {
  display: flex;
  align-items: center;
}
.pc-header-auto span img {
  width: 160px;
  height: 40px;
  cursor: pointer;
}
.pc-header-auto span em {
  display: flex;
  height: 24px;
  align-items: center;
  border-left: 1px solid #e8e8e8;
  margin-left: 16px;
  padding-left: 16px;
  font-weight: 500;
  font-size: 18px;
  color: #333;
}
.pc-content {
  width: 1200px;
  margin: 24px auto;
  background: #fff;
  padding: 40px;
  border-radius: 8px;
  min-height: calc(100vh - 160px);
}
.page-nav {
  margin-bottom: 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.booking-btn {
  background: #883032;
  border-color: #883032;
  flex-shrink: 0;
}
.reserve-main-layout {
  display: flex;
  gap: 32px;
}
.reserve-content-area {
  flex: 1;
  min-width: 0;
}
.selection-panel {
  background: #f9fafc;
  padding: 24px;
  border-radius: 12px;
  margin-bottom: 32px;
  border: 1px solid #edf2f7;
}
.panel-section {
  margin-bottom: 24px;
}
.section-title-small {
  font-size: 15px;
  font-weight: 600;
  color: #4a5568;
  margin-bottom: 12px;
}
.week-selector-pc {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}
.week-card-pc {
  width: 86px;
  height: 70px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}
.week-card-pc:hover {
  border-color: #883032;
  color: #883032;
}
.week-card-pc.active {
  background: #883032;
  border-color: #883032;
  color: #fff;
}
.week-day { font-size: 13px; margin-bottom: 4px; }
.week-date { font-size: 16px; font-weight: bold; }

.legend-panel {
  display: flex;
  align-items: center;
  gap: 24px;
  padding-top: 16px;
  border-top: 1px solid #edf2f7;
}
.legend-item { display: flex; align-items: center; font-size: 14px; color: #718096; }
.box { width: 18px; height: 18px; border-radius: 4px; margin-right: 8px; }
.not-optional { background: #edf2f7; border: 1px solid #e2e8f0; }
.optional { background: #fff; border: 2px solid #883032; }
.selected { background: #883032; border: 2px solid #883032; }
.bc-notice { margin-left: auto; color: #883032; font-size: 14px; display: flex; align-items: center; gap: 8px; }
.highlight { font-weight: bold; }

.reserve-grid-container {
  overflow: hidden;
  border-radius: 12px;
  border: 1px solid #e8e8e8;
}
.table-wrapper {
  overflow-x: auto;
}
.venue-reserve-table-pc {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}
.venue-reserve-table-pc th, .venue-reserve-table-pc td {
  border: 1px solid #f0f0f0;
  padding: 0;
  text-align: center;
}
.venue-reserve-table-pc th {
  background: #fafafa;
  height: 50px;
  font-weight: 600;
  color: #262626;
}
.sticky-col {
  position: sticky;
  left: 0;
  z-index: 10;
}
.first-col { background: #fafafa !important; width: 120px; }
.time-label { background: #fff; height: 60px; font-weight: 500; color: #595959; border-right: 2px solid #f0f0f0; }

.cell-content { padding: 6px; height: 100%; width: 100%; }
.reserve-slot {
  height: 48px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  font-size: 14px;
  position: relative;
  transition: all 0.2s;
}
.reserve-slot.available {
  cursor: pointer;
  border: 1px solid #e2e8f0;
}
.reserve-slot.available:hover {
  border-color: #883032;
  color: #883032;
  background: rgba(136, 48, 50, 0.02);
}
.reserve-slot.selected {
  background: #883032;
  border-color: #883032;
  color: #fff;
}
.reserve-slot.disabled {
  background: #f7fafc;
  color: #cbd5e0;
  cursor: not-allowed;
}
.slot-price { font-weight: 600; }
.slot-check { position: absolute; top: 2px; right: 2px; font-size: 12px; }

.reserve-sidebar {
  width: 320px;
}
.sidebar-card {
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 12px;
  padding: 24px;
  position: sticky;
  top: 104px;
}
.sidebar-title { font-size: 20px; font-weight: bold; margin-bottom: 24px; color: #333; }
.sidebar-section { margin-bottom: 24px; }
.section-label { font-size: 14px; font-weight: 600; color: #4a5568; margin-bottom: 12px; }
.service-summary { margin-top: 12px; font-size: 13px; color: #883032; }

.price-details-pc { margin-bottom: 24px; }
.price-item { display: flex; justify-content: space-between; margin-bottom: 12px; color: #718096; font-size: 15px; }
.price-item.discount span:last-child { color: #38a169; }
.price-total { display: flex; justify-content: space-between; align-items: center; margin-top: 16px; padding-top: 16px; border-top: 2px dashed #edf2f7; }
.price-total span:first-child { font-weight: bold; color: #2d3748; }
.total-val { font-size: 28px; font-weight: 800; color: #883032; }

.submit-booking-btn { height: 56px; font-size: 18px; font-weight: bold; border-radius: 8px; margin-bottom: 24px; }

.notice-info { background: #fffcf6; border: 1px solid #fff5e6; border-radius: 8px; padding: 16px; }
.notice-title { font-size: 14px; font-weight: bold; color: #b7791f; margin-bottom: 8px; display: flex; align-items: center; gap: 6px; }
.notice-content-pc { font-size: 13px; color: #975a16; line-height: 1.6; max-height: 200px; overflow-y: auto; }

.agreement-container-pc { padding: 0 20px; }
.agreement-content-scroll { max-height: 450px; overflow-y: auto; margin-bottom: 24px; padding-right: 12px; }
.agreement-h2 { text-align: center; font-size: 22px; font-weight: bold; margin-bottom: 24px; }
.agreement-body { line-height: 1.8; color: #4a5568; }
.agreement-footer-pc { text-align: center; padding-top: 16px; border-top: 1px solid #e8e8e8; }

.foot { text-align: center; padding: 40px 0; color: #999; font-size: 14px; }
</style>

<style>
/* 全局强制样式，确保 Ant Design 弹窗组件在 PC 端显示在最上层 */
.ant-modal-mask {
  z-index: 10000 !important;
}
.ant-modal-wrap {
  z-index: 10001 !important;
}
.ant-modal-root {
  position: relative;
  z-index: 10000 !important;
}
/* 解决弹窗可能出现的定位偏移问题 */
.ant-modal-centered .ant-modal {
  top: 0;
  padding-bottom: 0;
}
</style>
